import { defineStore } from 'pinia'

import type { LessonRecurringStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'
import { createLessonRecurringState } from './state'

export const useLessonRecurringStore = defineStore('lesson-recurring', {
  state: (): LessonRecurringStore => createLessonRecurringState(),
  actions,
  getters,
})
